import { useProfileQuery, useUpdateUserPreferencesMutation } from '@/queries/user';

export const useCurrentUser = () => {
  const { data } = useProfileQuery();
  const { mutateAsync } = useUpdateUserPreferencesMutation();

  return {
    data,
    updateUserPreferences: mutateAsync,
  };
};
